import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Box, Button } from '@mui/material';
import { useSnackbar } from '@contexts/SnackbarContext';
import API from '@utils/axios';

function CustomerThresholds({ customer, type, onSuccess }) {
    const { t } = useTranslation();
    const { showMessage } = useSnackbar();
    const [thresholds, setThresholds] = useState({
        alert: '',
        stop: ''
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const customerThresholds = customer.credits_thresholds?.[type] || {};
        setThresholds({
            alert: customerThresholds.alert ?? '',
            stop: customerThresholds.stop ?? ''
        });
    }, [customer, type]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const updatedThresholds = {
                credits_thresholds: {
                    [type]: {
                        alert: parseInt(thresholds.alert) || 0,
                        stop: parseInt(thresholds.stop) || 0
                    }
                }
            };

            await API.put(`/customers/${customer.id}`, updatedThresholds);
            showMessage(t('Thresholds updated successfully'), 'success');
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            console.error('Error updating thresholds:', error);
            showMessage(t('Error updating thresholds'), 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: { xs: 'column', sm: 'row' }, 
                gap: 2, 
                alignItems: { xs: 'center', sm: 'flex-start' }, 
                mb: 2 
            }}>
                <TextField
                    fullWidth
                    label={t('Alert threshold')}
                    type="number"
                    value={thresholds.alert}
                    onChange={(e) => setThresholds({ ...thresholds, alert: e.target.value })}
                    helperText={t('Send alert when credits fall below this value')}
                />
                <TextField
                    fullWidth
                    label={t('Stop threshold')}
                    type="number"
                    value={thresholds.stop}
                    onChange={(e) => setThresholds({ ...thresholds, stop: e.target.value })}
                    helperText={t('Pause sending when credits fall below this value')}
                />
                <Button
                    variant="contained"
                    type="submit"
                    disabled={loading}
                    sx={{ 
                        mt: { xs: 1, sm: 0 },
                        minWidth: '110px',
                        alignSelf: { xs: 'center', sm: 'center' }
                    }}
                >
                    {t('Save')}
                </Button>
            </Box>
        </form>
    );
}

export default CustomerThresholds; 
